
import { UrleventLog, appVersion } from './auth'
import axios from 'axios';

export const sendToeventLog = (
   userId = null,
   param = null,
   sourceDb = null,
   path = null,
   action = "EnterPage",
   description = null,
   clientInfo = `{'appVersion':'${appVersion()}','APP_TYPE':'WEB'}`
) => {
   let object = JSON.stringify({
      userId,
      param,
      sourceDb,
      path,
      action,
      description,
      clientInfo
   })

   // console.log('objectobjobjectect', object)
   let customConfig = {
      headers: {
      'Content-Type': 'application/json'
      }
  };
   axios.post(`${UrleventLog()}`,
               {
                  userId,
                  param,
                  sourceDb,
                  path,
                  action,
                  description,
                  clientInfo
               }, customConfig)
               .then(response => {
                   const data = response
                   console.log('asdasdasd', data)
                  //  this.setState({
                  //      dataMeeting: data
                  //  })
                   // console.log("response",response);
               }).catch(
                   error => console.error(`Error: ${error}`)
               )
}